module.exports = __webpack_public_path__ + "img/content_image4.c9498118.png";